import { isEmpty } from "lodash";

import { definitionActionTypes } from "../../../definition";
import { colorActionTypes } from "../../../definition/colors";
import { actionTypes as itemActionTypes } from "../../../items/actions";
import rootActionTypes from "../../../rootActionTypes";
import { getAffectedActionIds } from "./getIdsFromActions";

const individualActionTypes = [
  //#!if readonly !== true
// itemActionTypes.EDIT_COLOR,
// itemActionTypes.CREATE_ITEM,
// itemActionTypes.AUTO_MATCH_FILTERS
  //#!endif
];

const globalActionTypes = [
  //#!if readonly !== true
// colorActionTypes.CHANGE_COLOR,
// colorActionTypes.DELETE_COLOR,
  //#!endif
  rootActionTypes.LOAD_FILE,
  rootActionTypes.UPDATE_FILE,
  rootActionTypes.LOAD_SAMPLE,
  definitionActionTypes.REPLACE_DEFINITIONS
];

// Changes:
//   - color [converted to swatchColor]
//   - colorId [orig value from ItemRecord]
//   - colorLabel: null
const applyColorUpdates = (state, action, newItemsById, newColorsById) => {
  const { affectedIds } = getAffectedActionIds(state, action, globalActionTypes, individualActionTypes);

  if (affectedIds.length) {
    return state.withMutations(s => {
      // Iterate through each action and use the color in the action
      // Prep the new values that will go everywhere
      affectedIds.forEach(cId => {
        const item = newItemsById.get(cId);
        const dispItem = state.get(cId);
        const colorId = item.color;
        const colorRec = newColorsById.get(colorId);
        const color = colorRec ? colorRec.swatchColor : colorId;
        const colorLabel = colorRec ? colorRec.label : "";

        let changes = {};
        if (colorId !== dispItem.colorId) {
          changes.colorId = colorId;
        }
        if (color !== dispItem.color) {
          changes.color = color;
        }
        if (colorLabel !== dispItem.colorLabel) {
          changes.colorLabel = colorLabel;
        }

        if (!isEmpty(changes)) {
          s.update(cId, d => d.merge(changes));
        }
      });
    });
  }
  return state;
};

export default applyColorUpdates;
